import { getRouters, getHyzxRouters } from "@/api"
const routerStore = {
    state: {
        // 首页菜单路由
        navMenuRoutes: [],
        // 会员中心菜单路由
        hyzxMenuRoutes: [],
    },
    mutations: {
        SET_NAV_MENU_ROUTES(state, routes) {
            state.navMenuRoutes = routes;
        },
        SET_HYZX_MENU_ROUTES(state, routes) {
            state.hyzxMenuRoutes = routes;
        }
    },
    actions: {
        // 获取首页路由
        GenerateRoutes({ commit }) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                getRouters().then(res => {
                    const routesRes = res.data;
                    const filterRes = filterAsyncRouter(routesRes);
                    commit('SET_NAV_MENU_ROUTES', filterRes);
                    resolve(filterRes);
                })
            })
        },
        // 获取会员中心路由
        GetHyzxRoutes({ commit }) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                getHyzxRouters().then(res => {
                    const filterRes = filterAsyncRouter(res.data);
                    commit('SET_HYZX_MENU_ROUTES', filterRes);
                    resolve(filterRes)
                })
            })
        }
    }

}
const filterAsyncRouter = (accessRoutes) => {
    return accessRoutes.filter(route => {
        if (route.query) {
            route.path = route.path + "/" + route.query
        }

        if (route.children != null && route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children)
        } else {
            delete route['children']
            delete route['redirect']
        }
        return true
    })
}
export default routerStore
